import React from "react";

export function useRunOnMount(fn: () => void): void {
  React.useEffect(() => {
    return fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
